import React from "react";
import { Navigate } from "react-router-dom";
import { useAdmin } from "./AdminContext.js";

const ProtectedRoute = ({ children }) => {
  console.log("✅ ProtectedRoute component rendering...");

  const { isAuthenticated, loading } = useAdmin();
  console.log("🔍 useAdmin() values — isAuthenticated:", isAuthenticated, "| loading:", loading);

  if (loading) {
    console.log("⏳ Loading is true — displaying loading message...");
    return <div>Loading...</div>; // or a custom spinner
  }

  if (!isAuthenticated) {
    console.log("🚫 User is NOT authenticated — redirecting to /employee-login");
    return <Navigate to="/employee-login" replace />; // or your admin login page route
  }

  console.log("✅ User is authenticated — rendering protected children components.");
  return children;
};

export default ProtectedRoute;
